import React from 'react'

function Hero() {
    return ( 
        <div className="container p-5 mb-5">
        <div className="row text-center d-flex flex-column align-items-center">

        <div className="signup-hero">
  <h1>Open your free paper trading account</h1>
  <p>Practice investing with virtual capital. Zero risk. Real market simulation.</p>
</div>
      </div>
      </div>
     );
}

export default Hero;